import React, { useState, useMemo, useEffect } from "react";
import ContentBlock from "../Layout/ContentBlock";
import TableFilterBox from "../common/TableFilterBox";
import { DebounceSelect } from "../common";
import ContentValidation from "../common/ContentValidation";
import Axios from "axios";
import {
  InputSwitchComponent,
  Pagination,
  SelectCountry,
  SelectInput,
} from "../globals";

import { ButtonRollback, ButtonOpenExcel } from "../common/Buttons";
import { IconOpenVector, IconTimerStatistics } from "../Layout/Icons";
import { flag_icons, getDateFormat } from "../../helpers/Utils";
import RangePickerComp from "../common/RangePickerComp";
import { Tooltip, Checkbox } from "antd";
import ImumStatisticsModal from "./ImumStatisticsModal";
import { useQuery } from "react-query";
import axios from "axios";
import { rollbackImumToPim, getImumXls } from "../../redux/Actions/imum_action";
import dayjs from "dayjs";

const ImumStatistics = ({
  page,
  setPage,
  perPage,
  setTotals,
  totals,
  setLength,
}) => {
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [logItemId, setLogItemId] = useState(null);
  const [titleValue, setTitleValue] = useState("");
  const [countriesFilter, setCountriesFilter] = useState([]);
  const [skuFilter, setSkuFilter] = useState("");
  const [initiatorFilter, setInitiatorFilter] = useState([]);
  const [exportDateFilter, setExportDateFilter] = useState("");
  const [statusFilter, setStatusFilter] = useState("");
  const [checked, setChecked] = useState([]);
  const [filterString, setFilterString] = useState("");
  const [tabKey, setTabKey] = useState("1");
  const fetchLogItemsFull = async () => {
    let url = `/api/v1/${window.identifier}/imums/log_items_full?page=${page}&per_page=${perPage}`;

    if (Array.isArray(countriesFilter) && countriesFilter.length) {
      url += `&q[countries][]=${countriesFilter.join("&q[countries][]=")}`;
    }

    if (Array.isArray(initiatorFilter) && initiatorFilter.length) {
      const userInitiators = initiatorFilter
        .filter((initiator) => initiator.startsWith("user"))
        .map((initiator) => `q[user_id_in][]=${initiator.replace("user", "")}`)
        .join("&");

      const ruleInitiators = initiatorFilter
        .filter((initiator) => initiator.startsWith("rule"))
        .map(
          (initiator) => `q[imum_rule_id_in][]=${initiator.replace("rule", "")}`
        )
        .join("&");

      const initiatorQueryParam = [userInitiators, ruleInitiators]
        .filter(Boolean)
        .join("&");

      url += url.includes("?")
        ? `&${initiatorQueryParam}`
        : `?${initiatorQueryParam}`;
    }

    if (exportDateFilter?.length) {
      url += `&q[created_at_gteq]=${exportDateFilter[0]}&q[created_at_lteq]=${exportDateFilter[1]}`;
    }

    if (skuFilter?.length) {
      url += url.includes("?")
        ? `&q[sku]=${skuFilter}`
        : `?q[sku]=${skuFilter}`;
    }

    if (statusFilter === "1") {
      url += url.includes("?")
        ? `&q[has_exports]=true`
        : `?q[has_exports]=true`;
    }

    if (statusFilter === "0") {
      url += url.includes("?") ? `&q[has_errors]=true` : `?q[has_errors]=true`;
    }

    const response = await axios.get(url);
    setTotals(response?.data?.totals);
    setLength(response?.data?.data?.length);
    setFilterString(
      url.replace(`/api/v1/${window.identifier}/imums/log_items_full?`, "")
    );
    return response.data;
  };
  console.log(initiatorFilter, "initiatorFilterą");
  const {
    data: logItemsFullData,
    isLoading,
    refetch,
  } = useQuery("logItemsFull", fetchLogItemsFull);

  const fetchLogItemsInitiators = async () => {
    let url = `/api/v1/${window.identifier}/imums/log_initiators`;
    const response = await axios.get(url);
    return response.data;
  };

  const fetchOptions4Filter = async (value, type) => {
    try {
      let api_url = `/api/v1/imums/simple_imum_products?q[brand_i_cont_any]=${value}`;
      if (type === "user" && value?.length < 3) {
        return [
          {
            label: "No data available",
            value: "",
          },
        ];
      }
      if (type === "family") {
        api_url = `/api/v1/imums/simple_imum_products?q[imum_category_i_cont_any]=${value}`;
      } else if (type === "product_code") {
        api_url = `/api/v1/imums/simple_imum_products?q[product_code_i_cont_any]=${value}`;
      } else if (type === "product_name") {
        api_url = `/api/v1/imums/simple_imum_products?q[product_name_i_cont_any]=${value}`;
      } else if (type === "user" && value?.length >= 3) {
        api_url = `/api/v1/users?q[firstname_i_cont]=${value}&q[deleted_at_null]=true`;
      }

      const { data } = await Axios.get(api_url);
      const valArr = data?.data || [];

      const options = [
        {
          label: "No data selected",
          value: "",
        },
        ...valArr.map((e) => {
          if (type === "user") {
            return {
              value: e.id,
              label: `${e.firstname} ${e.lastname}`,
            };
          } else if (["product_name", "product_code"].includes(type)) {
            return {
              value: e.product_code,
              label: `${e.product_code} - ${e.product_name}`,
            };
          } else {
            const val = type === "brand" ? e.brand : e.imum_category;
            return {
              value: val,
              label: val,
            };
          }
        }),
      ];

      if (type === "family") {
        options.splice(1, 0, {
          label: "No Category",
          value: "no_category",
        });
      }

      return options;
    } catch (err) {
      console.log(err);
      return [];
    }
  };

  const { data: logItemsInitiatorsData, refetch: refetchLogItemsInitiators } =
    useQuery("logItemsInitiators", fetchLogItemsInitiators);

  const handleClick = (id, title, key) => {
    setLogItemId(id);
    setTitleValue(title);
    showModal();
  };

  const showModal = () => {
    setIsModalVisible(true);
  };

  const handleCancel = () => {
    setIsModalVisible(false);
  };

  const handleFilterChange = () => {
    refetch();
  };

  const handleFilterClear = () => {
    setCountriesFilter([]);
    setInitiatorFilter([]);
    setExportDateFilter("");
    setStatusFilter("");
    setSkuFilter("");
  };

  const handleCheckboxChange = (id) => {
    setChecked((prevChecked) =>
      prevChecked.includes(id)
        ? prevChecked.filter((itemId) => itemId !== id)
        : [...prevChecked, id]
    );
  };

  const handleCheckAllChange = () => {
    if (checked.length === logItemsFullData?.data?.length) {
      setChecked([]);
    } else {
      setChecked(logItemsFullData?.data?.map((item) => item.id));
    }
  };

  const userOptions = useMemo(() => {
    if (!logItemsInitiatorsData) return [];

    const users = logItemsInitiatorsData?.data?.users?.map((user) => ({
      label: user.title,
      value: `user${user.id}`,
    }));

    const rules = logItemsInitiatorsData?.data?.rules?.map((rule) => ({
      label: rule.title,
      value: `rule${rule.id}`,
    }));

    return [...users, ...rules];
  }, [logItemsInitiatorsData]);

  useEffect(() => {
    refetch();
    refetchLogItemsInitiators();
  }, [perPage, page]);

  return (
    <>
      <div className="row">
        <ContentBlock containerClass="pt-3">
          <TableFilterBox
            add={false}
            filter={true}
            onFilter={() => handleFilterChange()}
            clearFilter={() => handleFilterClear()}
            export={
              <div className="dropdown">
                <button
                  className="btn btn-sm btn-dark float-right mr-3 dropdown-toggle"
                  type="button"
                  id="dropdownMenuButton"
                  data-toggle="dropdown"
                  aria-haspopup="true"
                  aria-expanded="false"
                >
                  Export
                </button>
                <div
                  className="dropdown-menu dropdown-menu-right"
                  aria-labelledby="dropdownMenuButton"
                >
                  {logItemsFullData?.data?.length > 0 && (
                    <>
                      <button
                        className="dropdown-item"
                        onClick={() =>
                          getImumXls({
                            type: "get_log_xls",
                            ids: [...checked],
                            filter: null,
                          })
                        }
                      >
                        Export selected (XLS)
                      </button>
                      <button
                        className="dropdown-item"
                        onClick={() =>
                          getImumXls({
                            type: "get_log_xls",
                            filter: filterString,
                          })
                        }
                      >
                        Export filtered (XLS)
                      </button>
                    </>
                  )}
                </div>
              </div>
            }
          >
            {window.identifier !== "technorama" && (
              <div className="px-1">
                <SelectCountry
                  mode="multiple"
                  value={countriesFilter}
                  style={{ width: 165 }}
                  onChange={(value) => setCountriesFilter(value)}
                />
              </div>
            )}

            <div className="px-1">
              <RangePickerComp
                style={{ width: 250 }}
                label="Export date"
                showTime={{ format: "HH:mm" }}
                placeholder={["Start time", "End time"]}
                value={
                  exportDateFilter
                    ? [
                        getDateFormat(exportDateFilter[0]),
                        getDateFormat(exportDateFilter[1]),
                      ]
                    : ["", ""]
                }
                onChange={(_, value) => {
                  setExportDateFilter(value);
                }}
                disabledDate={() => false}
              />
            </div>
            <div className="px-1">
              <SelectInput
                label="Initiator"
                mode="multiple"
                style={{ width: 165 }}
                options={userOptions}
                value={initiatorFilter}
                placeholder={"Enter"}
                onChange={(initiator) => {
                  console.log(initiator);
                  setInitiatorFilter(initiator);
                }}
              />
            </div>
            <div className="px-1">
              <DebounceSelect
                label="SKU"
                showSearch={true}
                value={skuFilter}
                placeholder={"Enter"}
                fetchOptions={(d) => fetchOptions4Filter(d, "product_code")}
                onChange={(value) => setSkuFilter(value.value)}
                style={{
                  width: 165,
                }}
              />
            </div>
            <div className="px-1">
              <InputSwitchComponent
                label="Show exports"
                name="active_true"
                options={[
                  {
                    label: "All",
                    value: "",
                  },
                  {
                    label: "Successfull",
                    value: "1",
                  },
                  {
                    label: "Unsuccessful",
                    value: "0",
                  },
                ]}
                value={statusFilter}
                onChange={(e) => setStatusFilter(e.target.value)}
              />
            </div>
          </TableFilterBox>
          <div>
            <ContentValidation
              loader={isLoading}
              array={logItemsFullData?.data || []}
            >
              <table className="table mt-3">
                <thead>
                  <tr className="text-muted">
                    <th className="text-black">
                      <Checkbox
                        onChange={handleCheckAllChange}
                        className="mr-2"
                        checked={
                          checked.length === logItemsFullData?.data?.length
                        }
                      />
                      Initiator
                    </th>
                    <th className="text-black">Countries</th>
                    <th className="text-black">Export date</th>
                    <th className="text-black">Successful export</th>
                    <th className="text-black">Unsuccessful export</th>
                    <th className="text-black"></th>
                  </tr>
                </thead>
                <tbody>
                  {logItemsFullData?.data?.map((item) => (
                    <tr className="align-middle tableColumn" key={item.id}>
                      <td className="align-middle">
                        <div className="d-flex flex-row align-items-center">
                          <Checkbox
                            onChange={() => handleCheckboxChange(item.id)}
                            className="mr-2"
                            checked={checked?.includes(item.id)}
                          />
                          <div>
                            <p style={{ marginBottom: 0 }}>
                              {item.rule || item.user}
                            </p>
                            {item.rule_time && (
                              <Tooltip
                                placement="top"
                                title="Rule initiation time"
                              >
                                <div className="rule-container">
                                  <p className="rule-title">Rule</p>
                                  <IconTimerStatistics />
                                  <p className="rule-time">{item.rule_time}</p>
                                </div>
                              </Tooltip>
                            )}
                          </div>
                        </div>
                      </td>
                      <td className="align-middle">
                        {item?.countries?.map((value) => (
                          <span key={value} className="pr-1">
                            {flag_icons[value?.toUpperCase()]}
                          </span>
                        ))}
                      </td>
                      <td className="align-middle">
                        {dayjs(item?.export_date).format("YYYY-MM-DD HH:mm")}
                      </td>
                      <td className="align-middle">
                        <div className="d-flex flex-row align-items-center">
                          <div
                            className="dot"
                            style={{ backgroundColor: "#699635" }}
                          />
                          <span className="mr-1">{item.export_count}</span>
                          <div
                            onClick={() => {
                              handleClick(item.id, item.rule), setTabKey("1");
                            }}
                            className="cursor-pointer pb-1"
                          >
                            <IconOpenVector />
                          </div>
                        </div>
                      </td>
                      <td className="align-middle">
                        <div className="d-flex flex-row align-items-center">
                          <div
                            className="dot"
                            style={{ backgroundColor: "#D60D00" }}
                          />
                          <span className="mr-1">{item.error_count}</span>
                          <div
                            onClick={() => {
                              handleClick(item.id, item.rule), setTabKey("2");
                            }}
                            className="cursor-pointer pb-1"
                          >
                            <IconOpenVector />
                          </div>
                        </div>
                      </td>
                      <td className="align-middle">
                        <div className="d-flex justify-content-end gap-5">
                          <Tooltip placement="top" title="Download XSLX">
                            <div>
                              <ButtonOpenExcel
                                className="d-flex justify-content-center align-items-center"
                                onClick={() =>
                                  getImumXls({
                                    type: "get_log_xls",
                                    ids: [item?.id],
                                    filter: null,
                                  })
                                }
                              />
                            </div>
                          </Tooltip>
                          <Tooltip placement="top" title="Rollback">
                            <div>
                              <ButtonRollback
                                className="d-flex justify-content-center align-items-center"
                                onClick={() => {
                                  rollbackImumToPim(item.id);
                                }}
                              />
                            </div>
                          </Tooltip>
                        </div>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
              <Pagination
                className="pb-3"
                setPagination={setPage}
                page={page}
                totals={totals}
                pageCount={perPage}
              />
            </ContentValidation>
          </div>
        </ContentBlock>
        <ImumStatisticsModal
          isModalVisible={isModalVisible}
          handleCancel={handleCancel}
          logItemId={logItemId}
          title={titleValue}
          tabKey={tabKey}
          setTabKey={setTabKey}
        />
      </div>
    </>
  );
};

export default ImumStatistics;
